import axios from 'axios';

const api = axios.create({
    //baseURL: 'http://127.0.0.1/backend', // zentrale API-URL
    baseURL: 'https://fuchsbot.ocame.de/backend', // zentrale API-URL
});

export default api;
